import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from '@mui/material/GridLegacy';
import { useContext } from 'react';
import { SeequentLogo } from '../../assets/SeequentLogo';
import { SEEQUENT_LOGO_WIDTH, SEEQUENT_LOGO_HEIGHT } from '../../constants';
import { LoginContext } from '../loginHandler/LoginContext';
import { useStyles } from './Background.styles';
export function Background({ children }) {
    const { imageList } = useContext(LoginContext);
    const { classes } = useStyles({ imageList });
    return (_jsxs(Grid, { className: classes.background, container: true, direction: "column", alignItems: "center", "automation-id": "background-root", children: [_jsx(Grid, { item: true, className: classes.topPlaceholder }), _jsxs(Grid, { className: classes.box, item: true, xs: 12, children: [_jsx("header", { className: classes.headerBlock, children: _jsx("h2", { className: classes.header, children: _jsx(SeequentLogo, { style: {
                                    display: 'block',
                                    width: SEEQUENT_LOGO_WIDTH,
                                    height: SEEQUENT_LOGO_HEIGHT,
                                } }) }) }), _jsx(Grid, { container: true, className: classes.body, direction: "column", alignItems: "center", justifyContent: "center", children: children })] })] }));
}
//# sourceMappingURL=Background.js.map